class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    if (this.button.classList.contains('is-loading')) return;

    const url = this.dataset.url;
    if (!url) return;

    this.button.classList.add('is-loading');
    this.button.setAttribute('aria-disabled', 'true');

    const separator = url.includes('?') ? '&' : '?';
    const fetchUrl = `${url}${separator}section_id=${this.dataset.sectionId}`;

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => this.renderNewProducts(responseText))
      .catch((error) => {
        window.console.error(error);
        this.button.classList.remove('is-loading');
        this.button.removeAttribute('aria-disabled');
      });
  }

  renderNewProducts(responseText) {
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const newProductGrid = parsedHTML.getElementById('product-grid');
    const currentProductGrid = document.getElementById('product-grid');

    if (newProductGrid && currentProductGrid) {
      currentProductGrid.insertAdjacentHTML('beforeend', newProductGrid.innerHTML);
    }

    const newLoadMoreButton = parsedHTML.querySelector('load-more-button');

    if (newLoadMoreButton && newLoadMoreButton.dataset.url) {
      this.dataset.url = newLoadMoreButton.dataset.url;
      this.button.classList.remove('is-loading');
      this.button.removeAttribute('aria-disabled');
    } else {
      this.remove();
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);
